import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ResultLink from '../../../shared/links/ResultLink';
import ReplayLink from '../../../shared/links/ReplayLink';
import { formatDate } from '../../../utils/date';
import { shouldShowReplayButton } from '../../../utils/horse';

const DateCell = (props) => {
    const videoDetail = get(props, 'videoDetail[0]');
    const shouldDisplayIcon = shouldShowReplayButton(videoDetail);

    return (
        <div className={`mp-form__dateWrapper${!shouldDisplayIcon ? '__noVideoIcon' : ''}`}>
            {shouldDisplayIcon && <ReplayLink {...props} />}
            <ResultLink
                courseName={props.courseName}
                courseUid={props.courseUid}
                raceDatetime={props.raceDatetime}
                raceInstanceUid={props.raceInstanceUid}
                raceInstanceTitle={props.raceInstanceTitle}
                className="mp-form__date"
            >
                {formatDate(props.raceDatetime, 'DDMMM')}
                <span className="hidden-sm-down">
                    {formatDate(props.raceDatetime, 'YY')}
                </span>
            </ResultLink>
        </div>
    );
};

DateCell.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
};

export default DateCell;



// WEBPACK FOOTER //
// ./src/js/human/form/components/DateCell.jsx